import abi from './abi.json';
import abiV2 from './abiV2.json';

import { Network } from '../../providers/Networks/useNetworks';
import { IContractConfig } from '../types';

export const hashupStoreConfig: { [network in Network]: IContractConfig } = {
	[Network.MUMBAI_TESTNET]: {
		abi,
		address: '0x9741708b2DeDE32c972D3EF7959Fa3262860E485',
	},
	[Network.POLYGON_MAINNET]: {
		abi,
		address: '0x9741708b2DeDE32c972D3EF7959Fa3262860E485',
	},
};

export const hashupStoreV2Config: { [network in Network]: IContractConfig } = {
	[Network.MUMBAI_TESTNET]: {
		abi: abiV2,
		address: '0x9741708b2DeDE32c972D3EF7959Fa3262860E485',
	},
	[Network.POLYGON_MAINNET]: {
		abi: abiV2,
		address: '0x9741708b2DeDE32c972D3EF7959Fa3262860E485',
	},
};
